export enum PartitionTableType {
  Unsupported = -1,
  Unknown = 0,
  GuidedPartition = 1,
  MBRPartition = 2,
  Dynamic = 3,
  EntireDis = 4
}
